module.exports = __webpack_public_path__ + "media/images/khan_academy_logo-075ac0e773043905adc387f285ce36af.svg";